import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { Typography } from "../Typography";

export const Fieldset = styled.fieldset`
  ${() => {
    const { tokens } = useDesignTokens();
    const { fieldset } = tokens;

    return css`
      all: unset;
      box-sizing: border-box;
      width: 100%;
      display: grid;
      gap: ${fieldset.gap};
    `;
  }}
`;

export const Legend = styled(Typography).attrs({
  component: "legend",
})`
  display: flex;
  align-items: center;
  padding: 0;
`;
